var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 100,
    viewBox: "0 0 209 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 100,
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientEmpty);
export default __webpack_public_path__ + "static/media/ClientEmpty.7b55ac01d6bdb589eebb073559f60033.svg";
export { ForwardRef as ReactComponent };